import config from '../config';
import { request } from '../utils/request';

const jsnodeDomain = `${config.host}${config.apiRouter.jsnode}`;

const api = {
  // GetAProtocolOutSample
  get_a_protocol_out_sample (data) {
    return request.post(`${jsnodeDomain}/GetAProtocolOutSample`, data);
  },
};

export default api;
